import { h } from 'preact';
import { TextAreaEntry } from '../entries/TextAreaEntry';
import { CheckboxEntry } from '../entries/CheckboxEntry';

export class TransitionPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:SequenceFlow';
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('edge:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'transition',
        label: i18n.transition || 'Transition',
        entries: [
          {
            id: 'isDefault',
            component: () => (
              <CheckboxEntry
                id="epx-isDefault"
                label={i18n.isDefaultFlow || 'Default Flow'}
                checked={props.isDefault === true || props.isDefault === 'true'}
                onChange={(val) => update('isDefault', val)}
              />
            ),
          },
          {
            id: 'conditionExpression',
            component: () => (
              <TextAreaEntry
                id="epx-conditionExpression"
                label={i18n.conditionExpression || 'Condition Expression'}
                value={props.conditionExpression || ''}
                onChange={(val) => update('conditionExpression', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
